import {
  ContentMediumType,
  audioExtensions,
  imageExtensions,
  videoExtensions,
} from "../../constants/GlobalTypesAndEnumsAndConstants";
import { getYoutubeVideoId } from "./youtube-url";

const DOCUMENT_MIME_TYPES = new Set([
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
]);

const DOCUMENT_EXTENSIONS = new Set(["pdf", "doc", "docx", "ppt", "pptx"]);
// Markdown is always a document (the backend lays its text out as a PDF). A .txt file stays AnkiTxt here
// because it may be an Anki export; the uploader reads its text to tell (getTextFileContentMediumType).
const MARKDOWN_EXTENSIONS = new Set(["md", "markdown"]);
const MARKDOWN_MIME_TYPES = new Set(["text/markdown", "text/x-markdown"]);

function fileExtensionOf(filenameOrPageUrl: string): string {
  const cleanPath = filenameOrPageUrl.split(/[?#]/, 1)[0];
  const fileName = cleanPath.split("/").pop() || "";
  return fileName.includes(".") ? fileName.split(".").pop()?.toLowerCase() || "" : "";
}

export function getContentMediumTypeFromFileNameOrPageUrl(
  filenameOrPageUrl: string,
  fileType?: string
): ContentMediumType {
  const normalizedMimeType = fileType?.toLowerCase() || "";
  if (normalizedMimeType.startsWith("audio/")) return ContentMediumType.Audio;
  if (normalizedMimeType.startsWith("video/")) return ContentMediumType.Video;
  if (normalizedMimeType.startsWith("image/")) return ContentMediumType.Image;
  if (DOCUMENT_MIME_TYPES.has(normalizedMimeType)) return ContentMediumType.PDF;
  if (MARKDOWN_MIME_TYPES.has(normalizedMimeType)) return ContentMediumType.PDF;
  // Some systems label .md files text/plain.
  if (normalizedMimeType === "text/plain" && MARKDOWN_EXTENSIONS.has(fileExtensionOf(filenameOrPageUrl || ""))) return ContentMediumType.PDF;
  if (normalizedMimeType === "text/plain") return ContentMediumType.AnkiTxt;

  if (!filenameOrPageUrl) return ContentMediumType.Webpage;
  if (getYoutubeVideoId(filenameOrPageUrl)) return ContentMediumType.YouTubeVideo;

  const fileExtension = fileExtensionOf(filenameOrPageUrl);

  if (audioExtensions.includes(fileExtension)) return ContentMediumType.Audio;
  if (videoExtensions.includes(fileExtension)) return ContentMediumType.Video;
  if (imageExtensions.includes(fileExtension)) return ContentMediumType.Image;
  if (DOCUMENT_EXTENSIONS.has(fileExtension)) return ContentMediumType.PDF;
  // A web address ending in .md (a GitHub README) is still a web page.
  if (MARKDOWN_EXTENSIONS.has(fileExtension) && !/^[a-z][a-z0-9+.-]*:\/\//i.test(filenameOrPageUrl)) return ContentMediumType.PDF;
  if (fileExtension === "txt") return ContentMediumType.AnkiTxt;
  return ContentMediumType.Webpage;
}
